import { AIModel } from '../../services/zodiacEngine/AI/Core/AIVariants';

export enum Difficulty {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
  ZSTR = 'zstr',
  ZSTR_BLIND = 'zstr-blind',
}

export const DIFFICULTY_TO_MODEL: Record<Difficulty, AIModel> = {
  [Difficulty.EASY]: AIModel.ALCHEMIST,
  [Difficulty.MEDIUM]: AIModel.CREATURE,
  [Difficulty.HARD]: AIModel.SENTINEL,
  [Difficulty.ZSTR]: AIModel.ZSTR,
  [Difficulty.ZSTR_BLIND]: AIModel.ZSTR_BLIND,
};

export function modelToDifficulty(model: AIModel | null | undefined): Difficulty {
  if (model === AIModel.ZSTR_BLIND) return Difficulty.ZSTR_BLIND;
  if (model === AIModel.ZSTR) return Difficulty.ZSTR;
  if (model === AIModel.ALCHEMIST) return Difficulty.EASY;
  if (model === AIModel.SENTINEL) return Difficulty.HARD;
  return Difficulty.MEDIUM;
}

export function getDifficultyLabel(difficulty: Difficulty): string {
  switch (difficulty) {
    case Difficulty.EASY: return 'MCTS';
    case Difficulty.MEDIUM: return 'HRSTC';
    case Difficulty.HARD: return 'MM';
    case Difficulty.ZSTR: return 'ZSTR';
    case Difficulty.ZSTR_BLIND: return 'ZSTR Blind';
  }
}
